import { mapGetters } from 'vuex';
import marketIcon from '@/assets/icons/how-it-works/old/market.svg';
import predictionIcon from '@/assets/icons/how-it-works/old/prediction.svg';
import sharesIcon from '@/assets/icons/how-it-works/old/shares.svg';

export default {
  computed: {
    ...mapGetters('app', ['isShutdownModeOn']),
    ...mapGetters('user', ['isUserRestricted']),
    items() {
      if (this.isShutdownModeOn) {
        return [
          {
            title: 'Browsing Questions',
            description: 'Markets offer a range of questions for traders to test their skills.',
            icon: marketIcon,
          },
          {
            title: 'Making Predictions',
            description:
              'Traders make predictions by buying and selling shares in potential outcomes.',
            icon: predictionIcon,
          },
          {
            title: 'Trading Shares',
            description:
              'Prices will rise and fall with political events, giving traders the opportunity to cash in shares for a profit.',
            icon: sharesIcon,
          },
        ];
      }
      return [
        {
          title: 'Browse Markets',
          description:
            'Check out the range of available markets on which you can try and predict the outcome.',
          icon: marketIcon,
        },
        {
          title: 'Make A Prediction',
          description:
            'Think everyone’s got it wrong? Put your money where your mouth is and buy shares for or against an event taking place.',
          icon: predictionIcon,
        },
        {
          title: 'Trade Your Shares',
          description:
            'Buy your shares low and sell them high once the crowd figures out you were right.',
          icon: sharesIcon,
        },
      ];
    },
  },
};
